import {
  IconMinusRounded,
  IconPlus,
  IconScratchPad,
  IconCloudUpload,
  IconMagnify,
  IconQuester,
  IconCheck,
  IconReferenceGuide,
  IconNYQuesterLineReaderTool,
  IconRulerTool,
  IconProtractorTool,
  IconHighlighterTool,
} from '@edulastic/icons'
import React, { useState, useMemo, useEffect } from 'react'
import { withNamespaces } from '@edulastic/localization'
import { roleuser } from '@edulastic/constants'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { compose } from 'redux'
import styled from 'styled-components'
import questionType from '@edulastic/constants/const/questionType'
import { withWindowSizes, withKeyboard, EduIf } from '@edulastic/common'
import { TokenStorage } from '@edulastic/api'
import IconZoomReset from '@edulastic/icons/src/IconZoomReset'
import IconChangeThemeColor from '@edulastic/icons/src/IconChangeThemeColor'
import {
  getUserFeatures,
  getUserRole,
} from '../../../../author/src/selectors/user'
import { getIsPreviewModalVisibleSelector } from '../../../selectors/test'
import {
  setSelectedThemeAction,
  setZoomLevelAction,
} from '../../../../student/Sidebar/ducks'
import { themes } from '../../../../theme'
import ItemAudioControl from './ItemAudioControl'
import { getAccommodationsTtsSelector } from '../../../../student/Login/ducks'
import { isTextToSpeechEnabled } from '../../../utils/helpers'
import MagnifierDropDown from '../../../MangifierDropdown/magnifierDropDown'
import { magnifierSizes } from '../../../constants/assessmentPlayer'
import { getApplicableToolsForTestSkin } from '../../utils'
import {
  ANSWER_ELIMINATOR,
  BOOKMARK,
  CALCULATOR,
  CHECK_ANSWER,
  MAGNIFIER,
  PROTRACTOR,
  REFERENCE_MATERIAL,
  RULER,
  UPLOAD_WORK,
  ZOOM_IN,
  ZOOM_OUT,
  SCRATCHPAD as SCRATCHPAD_TOOL,
  LINE_READER,
  HIGHLIGHTER,
  ZOOM_RESET,
  CHANGE_COLOR_CONTRAST,
} from '../../constants'
import useLineReader from '../../../../common/components/LineReader/components/useLineReader'
import {
  hideLineReaderAction,
  lineReaderVisible,
  showLineReaderAction,
} from '../../../../common/components/LineReader/duck'
import ChangeColor from './ChangeColor'
import { updateTestPlayerAction } from '../../../../author/sharedDucks/testPlayer'
import Notes from '../../../components/Notes'

const {
  IconAnswerEliminator,
  IconBookMark,
  IconCalculator,
  IconNote,
} = IconQuester

const {
  playerSkin: { quester },
} = themes

const { footer, button } = quester

const zoomIndex = [1, 1.5, 1.75, 2.5, 3]

const CALC = 2
const CROSS_BUTTON = 3
const SCRATCHPAD = 5

const PlayerFooter = ({
  setZoomLevel,
  blockNavigationToAnsweredQuestions,
  defaultAP,
  toggleBookmark,

  currentItem,
  items,
  isBookmarked,
  t: i18Translate,
  changeTool,
  tool,
  qType,
  hasDrawingResponse,
  settings,
  showUserTTS,
  userRole,
  LCBPreviewModal,
  isTestPreviewModalVisible,
  windowWidth,
  toggleUserWorkUploadModal,
  enableMagnifier,
  handleMagnifier,
  answerChecksUsedForItem,
  checkAnswerInProgress,
  checkAnswer,
  isPremiumContentWithoutAccess = false,
  passage,
  openReferenceModal,
  canShowReferenceMaterial,
  calcTypes,
  userFeatures,
  onGeometryToolClick,
  visibleGeometryTools,
  originalSkinName,
  subjects,
  grades,
  isLineReaderVisible,
  setLineReader,
  hideLineReader,
  isHighlighterToolVisible,
  setHighlighterToolVisible,
  updateTestPlayer,
  isNoteVisible,
  hasNote = false,
}) => {
  const [zoom, setZoom] = useState(0)
  const [colorChoicePopoverVisible, setColorChoicePopoverVisible] = useState(
    false
  )

  const handleColorChoiceVisibleChange = (newVisible) => {
    setColorChoicePopoverVisible(newVisible)
  }

  const toggleNote = () => {
    updateTestPlayer({ isNoteVisible: !isNoteVisible })
  }

  const [isMagnifierDropdownVisible, setIsMagnifierDropdownVisible] = useState(
    false
  )
  const [isKeybordFocussed, setIsKeyboardFocussed] = useState(false)

  const {
    enableScratchpad,
    enableUploadWork,
    isTeacherPremium,
    showMagnifier,
    maxAnswerChecks,
    showTtsForPassages = true,
    showTextToSpeech,
  } = settings

  const [showReader, destoryReader] = useLineReader(hideLineReader)

  const isDisableCrossBtn = qType !== questionType.MULTIPLE_CHOICE

  const applicableTools = useMemo(
    () =>
      getApplicableToolsForTestSkin({
        playerSkinType: originalSkinName,
        subjects: subjects || [],
        grades: grades || [],
      }),
    [originalSkinName, subjects, grades]
  )

  const isToolApplicable = (_tool) => {
    return applicableTools.includes(_tool)
  }

  const handleLineReaderClick = () => {
    if (isLineReaderVisible) {
      destoryReader()
    } else {
      setLineReader()
    }
  }

  const handleZoomIn = () => {
    if (zoom !== zoomIndex.length - 1) {
      setZoomLevel(zoomIndex[zoom + 1])
      setZoom(zoom + 1)
    }
  }

  const handleZoomOut = () => {
    if (zoom !== 0) {
      setZoomLevel(zoomIndex[zoom - 1])
      setZoom(zoom - 1)
    }
  }

  const handleZoomReset = () => {
    setZoomLevel(1)
    setZoom(0)
  }

  const handleCheckAnswer = () => {
    if (checkAnswerInProgress || typeof checkAnswer !== 'function') {
      return null
    }
    checkAnswer()
  }

  const isTtsEnabled = isTextToSpeechEnabled(
    showTextToSpeech,
    showUserTTS,
    isTestPreviewModalVisible,
    userRole,
    userFeatures?.textToSpeech
  )
  const canShowPlayer =
    (isTtsEnabled && userRole === roleuser.STUDENT) ||
    (userRole !== roleuser.STUDENT && (!!LCBPreviewModal || isTtsEnabled))

  const hideCheckAnswer = !TokenStorage.getAccessToken()

  useEffect(() => {
    if (isLineReaderVisible) {
      showReader()
    }
    return () => {
      destoryReader()
    }
  }, [isLineReaderVisible])

  return (
    <MainFooter isSidebarVisible className="quester-player-footer">
      {isToolApplicable(ZOOM_RESET) && (
        <ActionContainer
          data-cy="zoomReset"
          onClick={handleZoomReset}
          aria-label={i18Translate('header:toolbar.zoomReset')}
          title={i18Translate('header:toolbar.zoomReset')}
          disabled={isPremiumContentWithoutAccess}
          style={{ paddingRight: '10px' }}
        >
          <IconWrap className="hover-effect">
            <IconZoomReset />
          </IconWrap>
          <span>{i18Translate('header:toolbar.zoomReset')}</span>
        </ActionContainer>
      )}

      {isToolApplicable(ZOOM_OUT) && (
        <ActionContainer
          data-cy="zoomOut"
          onClick={handleZoomOut}
          aria-label={i18Translate('header:toolbar.zoomOut')}
          disabled={isPremiumContentWithoutAccess}
        >
          <IconWrap className="hover-effect">
            <IconMinusRounded color={footer.textColor} />
          </IconWrap>
          <span>{i18Translate('header:toolbar.zoomOut')}</span>
        </ActionContainer>
      )}

      {isToolApplicable(ZOOM_IN) && (
        <ActionContainer
          data-cy="zoomIn"
          onClick={handleZoomIn}
          aria-label={i18Translate('header:toolbar.zoomIn')}
          disabled={isPremiumContentWithoutAccess}
        >
          <IconWrap className="hover-effect">
            <IconPlus color={footer.textColor} />
          </IconWrap>
          <span>{i18Translate('header:toolbar.zoomIn')}</span>
        </ActionContainer>
      )}

      {isToolApplicable(BOOKMARK) && !blockNavigationToAnsweredQuestions && (
        <ActionContainer
          hoverEffect
          active={isBookmarked}
          onClick={
            defaultAP
              ? toggleBookmark
              : () => toggleBookmark(items[currentItem]?._id)
          }
          title={i18Translate('header:toolbar.bookmark')}
          data-cy="bookmark"
          aria-label={i18Translate('header:toolbar.bookmark')}
          disabled={isPremiumContentWithoutAccess}
        >
          <IconWrapper>
            <IconBookMark
              color={isBookmarked ? button.background : footer.textColor}
              hoverColor={button.background}
            />
          </IconWrapper>

          <span>{i18Translate('header:toolbar.bookmark')}</span>
        </ActionContainer>
      )}
      <ActionContainer
        hoverEffect
        active={isNoteVisible || hasNote}
        onClick={toggleNote}
        title={i18Translate('header:toolbar.note')}
        data-cy="note"
        aria-label={i18Translate('header:toolbar.note')}
      >
        <IconWrapper>
          <IconNote color="transparent" hoverColor="transparent" />
        </IconWrapper>
        <span>{i18Translate('header:toolbar.note')}</span>
      </ActionContainer>
      <Devider />

      {isToolApplicable(REFERENCE_MATERIAL) && canShowReferenceMaterial && (
        <ActionContainer
          hoverEffect
          onClick={openReferenceModal}
          title={i18Translate('header:toolbar.refMaterial')}
          data-cy="referenceGuide"
          disabled={isPremiumContentWithoutAccess}
          aria-label={i18Translate('header:toolbar.refMaterial')}
        >
          <IconWrapper>
            <IconReferenceGuide
              color={footer.textColor}
              hoverColor={button.background}
            />
          </IconWrapper>

          <span>{i18Translate('toolbar.refMaterial')}</span>
        </ActionContainer>
      )}

      {isToolApplicable(HIGHLIGHTER) && (
        <ActionContainer
          hoverEffect
          active={isHighlighterToolVisible}
          onClick={() => setHighlighterToolVisible()}
          title={i18Translate('header:toolbar.highlighter')}
          data-cy="highlighter"
          aria-label={i18Translate('header:toolbar.highlighter')}
        >
          <IconWrapper>
            <IconHighlighterTool
              width={25}
              height={20}
              color={footer.textColor}
              hoverColor={button.background}
            />
          </IconWrapper>

          <span>{i18Translate('toolbar.highlighter')}</span>
        </ActionContainer>
      )}

      {isToolApplicable(CHECK_ANSWER) &&
        maxAnswerChecks > 0 &&
        !hideCheckAnswer && (
          <ActionContainer
            hoverEffect
            onClick={handleCheckAnswer}
            title={
              checkAnswerInProgress
                ? i18Translate(
                    'student:common.test.checkAnswerInfoTexts.inProgress'
                  )
                : answerChecksUsedForItem >= maxAnswerChecks
                ? i18Translate(
                    'student:common.test.checkAnswerInfoTexts.usageLimitExceeded'
                  )
                : i18Translate('student:common.test.checkanswer')
            }
            data-cy="checkAnswer"
            aria-label={i18Translate('student:common.test.checkanswer')}
            disabled={isPremiumContentWithoutAccess}
          >
            <IconCheck
              color={footer.textColor}
              hoverColor={button.background}
            />
            <span> {i18Translate('student:common.test.checkanswer')}</span>
          </ActionContainer>
        )}

      {isToolApplicable(CHANGE_COLOR_CONTRAST) && (
        <ChangeColor
          visible={colorChoicePopoverVisible}
          handleVisibleChange={handleColorChoiceVisibleChange}
        >
          <ActionContainer
            hoverEffect
            data-cy="changeColor"
            title={i18Translate('header:toolbar.changeColor')}
            aria-label={i18Translate('header:toolbar.changeColor')}
            disabled={isPremiumContentWithoutAccess}
            active={colorChoicePopoverVisible}
            onClick={() => changeTool(CHANGE_COLOR_CONTRAST)}
          >
            <IconWrapper>
              <IconChangeThemeColor />
            </IconWrapper>
            <span>{i18Translate('header:toolbar.changeColor')}</span>
          </ActionContainer>
        </ChangeColor>
      )}

      {isToolApplicable(ANSWER_ELIMINATOR) && (
        <ActionContainer
          hoverEffect
          active={tool?.includes(CROSS_BUTTON)}
          onClick={() => (isDisableCrossBtn ? null : changeTool(CROSS_BUTTON))}
          disabled={isDisableCrossBtn || isPremiumContentWithoutAccess}
          title={
            isDisableCrossBtn
              ? i18Translate('header:toolbar.crossDisabled')
              : i18Translate('header:toolbar.cross')
          }
          data-cy="crossButton"
          aria-label={i18Translate('header:toolbar.answerEliminator')}
        >
          <IconWrapper>
            <IconAnswerEliminator
              color={footer.textColor}
              hoverColor={button.background}
            />
          </IconWrapper>

          <span>{i18Translate('header:toolbar.answerEliminator')}</span>
        </ActionContainer>
      )}

      <EduIf condition={isToolApplicable(CALCULATOR) && !isEmpty(calcTypes)}>
        <ActionContainer
          hoverEffect
          active={tool?.includes(CALC)}
          onClick={() => changeTool(CALC)}
          title={i18Translate('header:toolbar.calculator')}
          data-cy="calculator"
          aria-label={i18Translate('header:toolbar.calculator')}
          disabled={isPremiumContentWithoutAccess}
        >
          <IconWrapper>
            <IconCalculator
              color={footer.textColor}
              hoverColor={button.background}
            />
          </IconWrapper>

          <span>{i18Translate('header:toolbar.calculator')}</span>
        </ActionContainer>
      </EduIf>

      {isToolApplicable(RULER) && (
        <ActionContainer
          hoverEffect
          active={visibleGeometryTools?.includes(RULER)}
          onClick={() => onGeometryToolClick(RULER)}
          title={i18Translate('header:toolbar.ruler')}
          data-cy="ruler"
          aria-label={i18Translate('header:toolbar.ruler')}
        >
          <IconWrapper>
            <IconRulerTool
              color={footer.textColor}
              hoverColor={button.background}
              height={21}
              width={16}
            />
          </IconWrapper>

          <span>{i18Translate('header:toolbar.ruler')}</span>
        </ActionContainer>
      )}

      {isToolApplicable(PROTRACTOR) && (
        <ActionContainer
          hoverEffect
          active={visibleGeometryTools?.includes(PROTRACTOR)}
          onClick={() => onGeometryToolClick(PROTRACTOR)}
          title={i18Translate('header:toolbar.protractor')}
          data-cy="protractor"
          aria-label={i18Translate('header:toolbar.protractor')}
        >
          <IconWrapper>
            <IconProtractorTool
              color={footer.textColor}
              hoverColor={button.background}
              height={21}
            />
          </IconWrapper>

          <span>{i18Translate('header:toolbar.protractor')}</span>
        </ActionContainer>
      )}

      <EduIf
        condition={
          isToolApplicable(SCRATCHPAD_TOOL) &&
          enableScratchpad &&
          !hasDrawingResponse
        }
      >
        <ActionContainer
          hoverEffect
          active={tool?.includes(SCRATCHPAD)}
          onClick={() => changeTool(SCRATCHPAD)}
          title={i18Translate('header:toolbar.scratchPad')}
          data-cy="scratchPad"
          aria-label={i18Translate('header:toolbar.scratchPad')}
          disabled={isPremiumContentWithoutAccess}
        >
          <IconWrapper>
            <IconScratchPad
              color={footer.textColor}
              hoverColor={button.background}
            />
          </IconWrapper>

          <span>{i18Translate('header:toolbar.scratchPad')}</span>
        </ActionContainer>
      </EduIf>

      <EduIf condition={isToolApplicable(MAGNIFIER) && showMagnifier}>
        <MagnifierDropDown
          disabled={isPremiumContentWithoutAccess}
          handleMagnifier={handleMagnifier}
          setIsMagnifierDropdownVisible={setIsMagnifierDropdownVisible}
          isMagnifierDropdownVisible={isMagnifierDropdownVisible}
          isKeybordFocussed={isKeybordFocussed}
          setIsKeyboardFocussed={setIsKeyboardFocussed}
        >
          <ActionContainer
            hoverEffect
            active={enableMagnifier}
            onClick={() => {
              setIsKeyboardFocussed(false)
              setIsMagnifierDropdownVisible(false)
              handleMagnifier(enableMagnifier ? '' : magnifierSizes.SMALL)
            }}
            title={i18Translate('header:toolbar.magnify')}
            data-cy="magnify"
            aria-label={i18Translate('header:toolbar.magnify')}
            aria-expanded={isMagnifierDropdownVisible}
            onFocus={() => setIsKeyboardFocussed(true)}
            role="button"
          >
            <IconWrapper>
              <IconMagnify
                color={footer.textColor}
                hoverColor={button.background}
              />
            </IconWrapper>

            <span>{i18Translate('header:toolbar.magnify')}</span>
          </ActionContainer>
        </MagnifierDropDown>
      </EduIf>

      <EduIf
        condition={
          isToolApplicable(UPLOAD_WORK) && isTeacherPremium && enableUploadWork
        }
      >
        <ActionContainer
          hoverEffect
          onClick={toggleUserWorkUploadModal}
          title={i18Translate('header:toolbar.uploadWork')}
          data-cy="uploadWork"
          aria-label={i18Translate('header:toolbar.uploadWork')}
          disabled={isPremiumContentWithoutAccess}
        >
          <IconWrapper>
            <IconCloudUpload
              color={footer.textColor}
              hoverColor={button.background}
            />
          </IconWrapper>

          <span>{i18Translate('header:toolbar.uploadWork')}</span>
        </ActionContainer>
      </EduIf>

      {isToolApplicable(LINE_READER) && (
        <ActionContainer
          hoverEffect
          active={isLineReaderVisible}
          onClick={handleLineReaderClick}
          title={i18Translate('header:toolbar.lineReader')}
          data-cy="lineReader"
          aria-label={i18Translate('header:toolbar.lineReader')}
        >
          <IconWrapper>
            <IconNYQuesterLineReaderTool
              color={footer.textColor}
              width={24}
              height={19}
            />
          </IconWrapper>

          <span>{i18Translate('header:toolbar.lineReader')}</span>
        </ActionContainer>
      )}

      <EduIf condition={canShowPlayer && windowWidth}>
        <ItemAudioControl
          passage={passage}
          item={items[currentItem]}
          windowWidth={windowWidth}
          isPremiumContentWithoutAccess={isPremiumContentWithoutAccess}
          showTtsForPassages={showTtsForPassages}
          view="preview"
        />
      </EduIf>
      {isNoteVisible && <Notes itemId={items[currentItem]?._id} />}
    </MainFooter>
  )
}

const enhance = compose(
  withNamespaces(['header', 'student']),
  withWindowSizes,
  connect(
    (state) => ({
      settings: state.test.settings,
      showUserTTS: getAccommodationsTtsSelector(state),
      userRole: getUserRole(state),
      timedAssignment: state.test?.settings?.timedAssignment,
      isTestPreviewModalVisible: getIsPreviewModalVisibleSelector(state),
      checkAnswerInProgress: state?.test?.checkAnswerInProgress,
      userFeatures: getUserFeatures(state),
      subjects: state?.test?.subjects,
      grades: state?.test?.grades,
      isLineReaderVisible: lineReaderVisible(state),
      isNoteVisible: state.testPlayer.isNoteVisible,
    }),
    {
      setSelectedTheme: setSelectedThemeAction,
      setZoomLevel: setZoomLevelAction,
      setLineReader: showLineReaderAction,
      hideLineReader: hideLineReaderAction,
      updateTestPlayer: updateTestPlayerAction,
    }
  )
)

export default enhance(PlayerFooter)

const MainFooter = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  display: flex;
  padding: 0 15px;
  z-index: 9999;
  background: ${footer.background};
  border-top: 1px solid ${footer.border};
  color: ${footer.textColor};
  font-size: 13px;
  height: 70px;
  .quester-question-audio-controller {
    position: relative;
    height: auto;
    padding: 0;
    margin-left: 5px;
    button {
      border-radius: 50%;
      width: 35px;
      height: 35px;
      padding: 3px 0 0 0;
      background: ${button.background} !important;
      border: none;
      float: left;
      &:focus,
      &:active,
      &:hover {
        background: ${button.background} !important;
        border: none !important;
        svg {
          fill: ${footer.background} !important;
        }
      }

      margin-right: 5px;
      svg {
        fill: ${footer.background};
      }
      .audio-pause {
        fill: ${footer.background};
      }
      .anticon-loading {
        position: relative;
        left: 0;
        top: 0;
      }
    }
  }
`

const ActionContainer = withKeyboard(styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  padding: 8px 15px;
  transition: all 0.5s ease;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 10px;
  ${(props) =>
    props.disabled &&
    `
    cursor:default;
    pointer-events:none;
    opacity: 0.4;
  `}
  ${(props) =>
    props.active &&
    `
      background-color: ${footer.hover.background};
      color: ${footer.hover.color};
    `}
  ${(props) =>
    props.hoverEffect &&
    !props.disabled &&
    `
      &:hover{
        background-color: ${footer.hover.background};
        color: ${footer.hover.color};
      }
    `}
`)

const IconWrap = styled.span`
  padding: 4px 15px 0px 15px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  border: 1px solid ${footer.textColor};
  &:hover {
    background-color: ${footer.hover.background};
    color: ${footer.hover.color};
  }
`
const Devider = styled.div`
  width: 1px;
  background: ${footer.hover.background};
`

const IconWrapper = styled.div`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`
